module.exports = __webpack_public_path__ + "static/media/blanco.2aba3a40.png";